import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Icon, Button } from 'shared/components';
import { AccessibilityContext } from 'App';

import theme from './ModalUploadMetaFailed.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
  fileName: PropTypes.string.isRequired,
};

const dismissMessage = { id: 'const.button.dismiss', defaultMessage: '** Dismiss' };
const titleMessage = { id: 'modal.uploadMetaFailed.title', defaultMessage: '** File is not approved' };
const bodyMessage = {
  id: 'modal.uploadMetaFailed.body',
  defaultMessage: '** The file { fileName } you tried to upload is not approved. You can try uploading a different file.',
};

const ModalUploadMetaFailed = ({
  intl,
  onCancel,
  fileName,
}) => (
  <div className={ theme.root }>
    <div className={ theme.header }>
      <div className={ theme.iconContainer }>
        <Icon className={ theme.icon } name="naked-x" />
      </div>
      <span className={ theme.message }>
        <FormattedMessage { ...titleMessage } />
      </span>
      <button onClick={ onCancel } className={ theme.closingIconContainer } aria-label={ intl.formatMessage({ id: 'General.Cancel', defaultMessage: '** Cancel' }) }>
        <Icon name="naked-x" />
      </button>
    </div>

    <div className={ theme.content }>
      <FormattedMessage { ...bodyMessage } values={{ fileName }} />
    </div>

    <div className={ theme.footer }>
      <Button
        testId="modal-upload-file-failed-dismiss-button"
        buttonType="naked"
        label={ intl.formatMessage(dismissMessage) }
        onClick={ onCancel }
      />
    </div>
  </div>
);

ModalUploadMetaFailed.propTypes = propTypes;

export default ModalUploadMetaFailed;
